import { styled } from '../../modules';
import { Button as ButtonComponent } from '../../components';

export const Button = styled(ButtonComponent)`
  margin-top: 1rem;
`;